var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2De3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 104,
    viewBox: "0 0 348 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_102_53)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52 92C74.0914 92 92 74.0914 92 52C92 29.9086 74.0914 12 52 12C29.9086 12 12 29.9086 12 52C12 74.0914 29.9086 92 52 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296 92C318.091 92 336 74.0914 336 52C336 29.9086 318.091 12 296 12C273.909 12 256 29.9086 256 52C256 74.0914 273.909 92 296 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173 92C195.091 92 213 74.0914 213 52C213 29.9086 195.091 12 173 12C150.909 12 133 29.9086 133 52C133 74.0914 150.909 92 173 92Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 46H133C132.517 51.1639 132.512 53.7514 133 58H91C91.6884 53.2693 91.6603 50.6397 91 46Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_102_53)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213 46H256C256 46 254.95 53.1859 256 58H213C213.807 53.315 213.337 50.685 213 46Z",
    fill: "#F7F7F7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M52 87C71.33 87 87 71.33 87 52C87 32.67 71.33 17 52 17C32.67 17 17 32.67 17 52C17 71.33 32.67 87 52 87Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173 87C192.33 87 208 71.33 208 52C208 32.67 192.33 17 173 17C153.67 17 138 32.67 138 52C138 71.33 153.67 87 173 87Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0114 39.7266V62.9993H52.0909V44.397H51.9545L46.625 47.7379V43.3743L52.3864 39.7266H57.0114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.886 62.9991V59.4536L174.17 51.7832C174.875 51.1014 175.466 50.4877 175.943 49.9423C176.428 49.3968 176.795 48.8627 177.045 48.34C177.295 47.8097 177.42 47.2377 177.42 46.6241C177.42 45.9423 177.265 45.3552 176.955 44.8627C176.644 44.3627 176.22 43.9802 175.682 43.715C175.144 43.4423 174.534 43.3059 173.852 43.3059C173.14 43.3059 172.519 43.4499 171.989 43.7377C171.458 44.0256 171.049 44.4385 170.761 44.9764C170.473 45.5143 170.33 46.1544 170.33 46.8968H165.659C165.659 45.3741 166.004 44.0521 166.693 42.9309C167.383 41.8097 168.348 40.9423 169.591 40.3286C170.833 39.715 172.265 39.4082 173.886 39.4082C175.553 39.4082 177.004 39.7036 178.239 40.2946C179.481 40.8779 180.447 41.6885 181.136 42.7264C181.826 43.7643 182.17 44.9536 182.17 46.2946C182.17 47.1733 181.996 48.0408 181.648 48.8968C181.307 49.7529 180.697 50.7036 179.818 51.7491C178.939 52.787 177.701 54.0332 176.102 55.4877L172.705 58.8173V58.9764H182.477V62.9991H165.886Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.489 63.3173C295.792 63.3173 294.28 63.0256 292.955 62.4423C291.636 61.8514 290.595 61.0408 289.83 60.0105C289.072 58.9726 288.682 57.7756 288.659 56.4196H293.614C293.644 56.9877 293.83 57.4877 294.17 57.9196C294.519 58.3438 294.981 58.6733 295.557 58.9082C296.133 59.143 296.78 59.2605 297.5 59.2605C298.25 59.2605 298.913 59.1279 299.489 58.8627C300.064 58.5976 300.515 58.2302 300.841 57.7605C301.167 57.2908 301.33 56.7491 301.33 56.1355C301.33 55.5143 301.155 54.965 300.807 54.4877C300.466 54.0029 299.973 53.6241 299.33 53.3514C298.693 53.0786 297.936 52.9423 297.057 52.9423H294.886V49.3286H297.057C297.799 49.3286 298.455 49.1999 299.023 48.9423C299.598 48.6847 300.045 48.3286 300.364 47.8741C300.682 47.412 300.841 46.8741 300.841 46.2605C300.841 45.6771 300.701 45.1658 300.42 44.7264C300.148 44.2794 299.761 43.9309 299.261 43.6809C298.769 43.4309 298.193 43.3059 297.534 43.3059C296.867 43.3059 296.258 43.4271 295.705 43.6696C295.152 43.9044 294.708 44.2415 294.375 44.6809C294.042 45.1203 293.864 45.6355 293.841 46.2264H289.125C289.148 44.8855 289.53 43.7036 290.273 42.6809C291.015 41.6582 292.015 40.8589 293.273 40.2832C294.538 39.6999 295.966 39.4082 297.557 39.4082C299.163 39.4082 300.568 39.6999 301.773 40.2832C302.977 40.8665 303.913 41.6544 304.58 42.6468C305.254 43.6317 305.587 44.7377 305.58 45.965C305.587 47.268 305.182 48.3552 304.364 49.2264C303.553 50.0976 302.496 50.6506 301.193 50.8855V51.0673C302.905 51.287 304.208 51.8817 305.102 52.8514C306.004 53.8135 306.451 55.018 306.443 56.465C306.451 57.7908 306.068 58.9688 305.295 59.9991C304.53 61.0294 303.473 61.84 302.125 62.4309C300.777 63.0218 299.231 63.3173 297.489 63.3173Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_102_53",
    x: 0,
    y: 0,
    width: 348,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_102_53",
    x: 6,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_102_53",
    x: 250,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_102_53",
    x: 127,
    y: 6,
    width: 92,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_102_53",
    x: 85,
    y: 40,
    width: 54,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_102_53",
    x: 207,
    y: 40,
    width: 55,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_102_53"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_102_53",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2De3);
export default __webpack_public_path__ + "static/media/2de3.384773525f1063fe5ce6cf63334cea1f.svg";
export { ForwardRef as ReactComponent };